import { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { Typography, Box, TextField, IconButton } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import axiosInstance from '../../../../utils/axios';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import Iconify from '../../../../reusable-components/iconify/Iconify';
import { BookingTypeSubmitRules } from '../../../../utils/globalEnums';

BookingAccountSearch.propTypes = {
  bookingType: PropTypes.object,
  onSelect: PropTypes.func
};

export default function BookingAccountSearch({ bookingType, onSelect }) {

  const [searchBookingVendor, setSearchBookingVendor] = useState('');
  const [bookingVendorData, setBookingVendorData] = useState([]);
  const [loadingBookingVendorData, setLoadingBookingVendorData] = useState(null);

  const fetchVendorAccounts = () => {
    setLoadingBookingVendorData(true);
    let url = `Vendor/SearchIntacctForVendor?vendor=${searchBookingVendor}&bookingTypeId=${bookingType?.id}`;
    if (bookingType?.submitType === BookingTypeSubmitRules.sendThroughWorkday) url = `Vendor/SearchWorkdayForVendor?search=${searchBookingVendor}`;
    else if (bookingType?.submitType === BookingTypeSubmitRules.sendThroughReliable ||
      bookingType?.submitType === BookingTypeSubmitRules.sendThroughQuickbooks) url = `Vendor/SearchBookingVendorForVendorCode?search=${searchBookingVendor}&bookingTypeId=${bookingType.id}`;
    axiosInstance.get(encodeURI(url))
      .then(res => setBookingVendorData(res.data?.map((data, index) => ({ ...data, id: index }))) ?? [])
      .catch(() => enqueueSnackbar('Failed to fetch booking vendor data', { variant: 'error' }))
      .finally(() => setLoadingBookingVendorData(false));
  } 

  const SelectButton = (params) => {
    const [selecting, setSelecting] = useState(false);

    return <LoadingButton loading={selecting} sx={{ padding: "2px" }} variant="contained" onClick={() => {
      setSelecting(true);
      setTimeout(() => {
        setSearchBookingVendor("");
        setBookingVendorData([]);
        setLoadingBookingVendorData(null);
        onSelect(params.row);
        setSelecting(false);
      }, 200);
    }}>
      Select
    </LoadingButton>
  };

  return <>
    <Box>
      <Typography variant="subtitle1">
        Search: {bookingType.label}
      </Typography>
      <TextField
        size="small"
        value={searchBookingVendor}
        onChange={(e) => setSearchBookingVendor(e.target.value)}
        fullWidth
        autoComplete="off"
        InputProps={{
          endAdornment: <IconButton
            color="secondary"
            disabled={loadingBookingVendorData}
            sx={{ display: searchBookingVendor === '' ? 'none' : 'inline-flex' }}
            onClick={fetchVendorAccounts}
          >
            <Iconify icon={'fa6-brands:searchengin'} sx={{ cursor: 'pointer' }} />
          </IconButton>
        }}
      />
    </Box>
    {loadingBookingVendorData != null && <CustomDataGrid
      gridId="admin-booking-account-vendorSearch"
      data={bookingVendorData}
      boxSX={{ height: '300px' }}
      scrollbarHeight={null}
      tableBoxSX={{ height: 'calc(100% - 50px)' }}
      gridColumns={[{
        field: 'account',
        headerName: 'Account',
        flex: 0.5,
        type: 'customSelect',
      },
      bookingType?.submitType === BookingTypeSubmitRules.sendThroughWorkday ? {
        field: 'subaccount',
        headerName: 'Subaccount',
        flex: 0.5,
        type: 'customText',
      } : null,
      {
        field: 'name',
        headerName: 'Name',
        flex: 0.5,
        type: 'customSelect',
      },
      (bookingType?.submitType === BookingTypeSubmitRules.sendThroughWorkday || bookingType?.submitType === BookingTypeSubmitRules.sendThroughReliable
          || bookingType?.submitType === BookingTypeSubmitRules.sendThroughQuickbooks) ? {
        field: 'address',
        headerName: 'Address',
        flex: 0.5,
        type: 'customText',
      } : null,
      onSelect ? {
        field: 'actions',
        headerName: 'Actions',
        disableReorder: true,
        width: 100,
        renderCell: SelectButton
      } : null].filter(col => col)}
      isLoading={loadingBookingVendorData}
    />}
  </>;
}
